import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './BrandOnboardingProgress.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCheckCircle } from '@fortawesome/pro-regular-svg-icons';

const BrandOnboardingProgress = props => {
  if (!props.brand?.id) return null;
  const { brand } = props;

  const sections = [
    {
      name: 'Registration',
      isComplete: brand.id
    },
    {
      name: 'Brand Name',
      isComplete: brand.name && brand.domain
    },
    {
      name: 'Brand Description',
      isComplete: brand.description
    },
    {
      name: 'Brand Competitors',
      isComplete: brand.competitor_brands?.length > 0
    },
    {
      name: 'Brand Images',
      isComplete: brand.logo && brand.mobileCoverImage && brand.mobileBadgeImage
    },
    {
      name: 'Connect Socials',
      isComplete: brand.social_accounts?.length > 0
    },
    {
      name: 'Affiliate Network',
      isComplete: brand.merchant_rate_info?.source
    },
    {
      name: 'Shopify App Connection',
      isComplete: brand.integrations?.length > 0
    },
    {
      name: 'Invoice',
      isComplete: brand.onboardingStatus === 'COMPLETE'
    }
  ];

  const completedCount = sections.filter(section => section.isComplete).length;
  return (
    <div className='brand-onboarding-progress-outer-container'>
      <div className='brand-onboarding-progress-inner-container'>
        <div className='brand-onboarding-progress-header'>
          <div className='brand-onboarding-progress-title'>Onboarding Progress</div>
          <div className='brand-onboarding-progress-count'>
            {completedCount} of {sections.length} complete
          </div>
        </div>

        <div className='brand-onboarding-progress-bar'>
          <div className='brand-onboarding-progress-bar-fill' style={{ width: `${(completedCount / sections.length) * 100}%` }} />
        </div>

        <div className='brand-onboarding-progress-sections'>
          {sections.map((section, index) => (
            <div className={cn('brand-onboarding-progress-section', { isComplete: section.isComplete })} key={index}>
              <FontAwesomeIcon icon={section.isComplete ? faCheckCircle : faCircle} />
              {section.name}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

BrandOnboardingProgress.propTypes = {
  brand: PropTypes.object
};

export default BrandOnboardingProgress;
